function Logo(props) {
  return <img alt="Logo" src="/static/logo_black_80.png" {...props} />;
}

export default Logo;
